var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "btn btn-wishlist",
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList")
      }
    },
    [
      _c(
        "svg",
        { staticClass: "icon icon-heart", attrs: { fill: "currentColor" } },
        [_c("use", { attrs: { "xlink:href": "#heart" } })]
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "ml-1 d-none d-sm-inline btn-wishlist__count" },
        [_vm._v(_vm._s(_vm.wishListCount))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }